module.exports = __webpack_public_path__ + "img/general5.269c5f96.jpg";